/* eslint-disable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */
import React from 'react';
import {
    PACKAGE_ONE,
    PACKAGE_TWO,
    PackageTypes,
    PROFESSIONAL_PACKAGE_DEFAULT_BANNER_TEXT,
    ESSENTIAL_PACKAGE_DEFAULT_BANNER_TEXT,
} from '../../constants/pricing';

import './pricingCalculatorBanner.scss';

interface BannerProps {
    currentPackage: PackageTypes;
    essentialsPackageBannerText?: string;
    handleCTAClick: Function;
    professionalPackageBannerText?: string;
}

const PricingCalculatorBanner = ({
    currentPackage = PACKAGE_TWO,
    essentialsPackageBannerText,
    handleCTAClick,
    professionalPackageBannerText,
}: BannerProps) => {
    const _handleClick = (e: React.MouseEvent) => {
        if ((e.target as HTMLDivElement).id === 'assortmentLink') {
            handleCTAClick();
        }
    };

    const renderOppositePackageCTA = () => {
        let markup;
        if (essentialsPackageBannerText && professionalPackageBannerText) {
            markup =
                currentPackage === PACKAGE_ONE
                    ? essentialsPackageBannerText
                    : professionalPackageBannerText;
        } else {
            markup =
                currentPackage === PACKAGE_ONE
                    ? PROFESSIONAL_PACKAGE_DEFAULT_BANNER_TEXT
                    : ESSENTIAL_PACKAGE_DEFAULT_BANNER_TEXT;
        }
        return <div dangerouslySetInnerHTML={{ __html: markup }} />;
    };
    return (
        <div className="eds-g-cell eds-g-cell-1-1 eds-g-group--full-width eds-bg-color--secondary-brand pricing-calculator-banner">
            <div
                className="eds-align--center eds-text--center eds-text-hs eds-text-color--inverse-primary-brand eds-pad-hor-6 pricing-calculator-banner--content"
                onClick={(e) => _handleClick(e)}
                role="button"
            >
                {renderOppositePackageCTA()}
            </div>
        </div>
    );
};

export default PricingCalculatorBanner;
